import {Component, Input, OnInit} from "@angular/core";
import { INoRowsOverlayAngularComp } from "ag-grid-angular";

@Component({
  standalone: false,
  selector: "wfm-esp-no-rows-overlay",
  templateUrl: "./no-rows-overlay.component.html",
  styleUrls: ["./no-rows-overlay.component.scss"]
})
export class EspNoRowsOverlayComponent implements OnInit, INoRowsOverlayAngularComp {

  @Input() params: any;

  constructor() { }

  ngOnInit() {
  }

  agInit(params: any): void {
    this.params = params;
  }

}
